import script from "./personnel-query-popup.vue?vue&type=script&lang=ts&setup=true"
export * from "./personnel-query-popup.vue?vue&type=script&lang=ts&setup=true"

import "./personnel-query-popup.vue?vue&type=style&index=0&id=64e1ab54&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64e1ab54"]])

export default __exports__